import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { BiMetricsResponseDataSchema, DataResponse, GetBiMetricsSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof BiMetricsResponseDataSchema>>
type Props = z.input<typeof GetBiMetricsSchema>

export const getBiMetricsQuery = (params: Props) => {
  return queryOptions({
    queryKey: ["backofficeBiMetrics", JSON.stringify(params)],
    queryFn: async () => {
      const { data } = await axios.get<Response>(`/backoffice/bi`, { params })
      return data.data
    },
  })
}
